import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts';
import {
  passengersCount,
  createDetailPriceList,
} from '../../../../utils/utility/booking';
import { BookingPriceDetails, Modal } from '../../..';
import { UsdCircleIcon } from '~svg';
//  priceList, parsedQueryStr, item, intl, isAgency;

const renderPriceDetailModal = (
  parsedQueryStr,
  selectFlight,
  intl,
  { isOpen, onClose },
) => {
  let isAgency = false;
  // (stakeholder = JSON.parse(localStorage.getItem("stakeholder"))),
  //   (isAgency =
  //     user &&
  //     stakeholder &&
  //     user.profiles &&
  //     user.profiles.some((item) => item.profileId === stakeholder));

  let passengers = [];
  if (parsedQueryStr.ad) passengers.push({ type: 'adult' });
  if (parsedQueryStr.ch) passengers.push({ type: 'child' });
  if (parsedQueryStr.in) passengers.push({ type: 'infant' });

  let priceList =
    selectFlight && selectFlight.itineraries
      ? createDetailPriceList(
          selectFlight,
          selectFlight ? selectFlight.totalPrice : 0,
          selectFlight ? selectFlight.commission : 0,
          passengers,
          'fa',
        )
      : [];

  return (
    <Modal
      title={intl.formatMessage({ id: 'booking.ticketPriceDetails' })}
      titleClass="text-primary"
      isOpen={isOpen}
      onClose={() => onClose(false)}
    >
      <div className="modal-body d-flex  flex-column justify-content-center p-0 m-0">
        {selectFlight && selectFlight.itineraries && (
          <BookingPriceDetails
            priceList={priceList}
            parsedQueryStr={parsedQueryStr}
            item={selectFlight}
            intl={intl}
            isAgency={isAgency}
          />
        )}
      </div>
    </Modal>
  );
};
const PassengerCount = ({ parsedQueryStr, selectFlight, intl, totalPrice }) => {
  const [isOpen, onClose] = useState(false);
  return (
    <div className="sec2 d-flex px-2 flex-column font-smaller font-xl-small w-100 border-bottom border-light pb-3 font-weight-bold">
      <div className=" py-2 d-flex justify-content-between">
        <span className=" d-flex align-items-center ">
          <UsdCircleIcon size={22} color="#85cd95" />
          <span className="text-white px-2 ">
            <FormattedMessage id="booking.totalpriceofpassengers" />
          </span>
        </span>
        <span
          className="cursor-pointer d-flex flex-end text-white border-button text-underline font-smaller"
          onClick={() => onClose(true)}
        >
          <FormattedMessage id="booking.pricedetail" />
        </span>
      </div>
      <div className="sec2-1 text-white d-flex w-100 justify-content-between align-items-center pt-2  ">
        <span className="d-flex px-4 ">
          <FormattedMessage id="booking.passengers" /> :
          <span className="px-1 d-flex">{passengersCount(parsedQueryStr)}</span>
        </span>
        <span className="d-flex text-white">
          {selectFlight?.totalPrice
            ? numberWithCommas(
                (
                  (parseFloat(selectFlight?.totalPrice || 0) +
                    parseFloat(selectFlight?.commission || 0)) /
                  10
                ).toFixed(0),
              )
            : totalPrice}

          <span className="d-flex px-1">
            <FormattedMessage
              id="booking.toman"
              defaultMessage="booking.toman"
            />
          </span>
        </span>
      </div>
      {renderPriceDetailModal(parsedQueryStr, selectFlight, intl, {
        isOpen,
        onClose,
      })}
    </div>
  );
};
export default injectIntl(PassengerCount);
